<template>
  <d-row class="justify-content-end">
    <d-col class="alert-wrapper mt-4" :class="{ 'position-fixed': fixed }">
      <d-alert
        dismissible
        :show="active"
        :theme="theme"
        @alert-dismissed="close"
        @alert-dismiss-countdown="handleTimeChange"
      >
        <span v-html="message"></span>
        {{ timeUntilDismissed }}seg.
      </d-alert>
    </d-col>
  </d-row>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'alert',
  props: {
    fixed: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      timeUntilDismissed: 0,
    };
  },
  computed: {
    active: {
      get() {
        return this.$store.state.alert.active;
      },
      set(value) {
        this.setAlert(value);
      },
    },
    theme() {
      return this.$store.state.alert.theme || 'secondary';
    },
    message() {
      return this.$store.state.alert.message;
    },
  },
  methods: {
    ...mapActions(['closeAlert', 'setAlert']),
    handleTimeChange(time) {
      this.timeUntilDismissed = time;
    },
    close() {
      this.timeUntilDismissed = 0;
      this.closeAlert();
    },
  },
};
</script>

<style lang="scss" scoped>
.alert-wrapper {
  width: auto;
  min-width: 400px;
  z-index: 99999;
}
</style>
